import React from "react"
import { logout } from "../../redux/apiCalls"
import { useDispatch } from "react-redux"
import { NotificationsNone, Language, Settings } from "@material-ui/icons"
// Styles
import {
   Container,
   Icons,
   Logo,
   TopAvatar,
   TopIconBadge,
   TopLeft,
   TopRight,
   Wrapper,
} from "./Topbar.styles"

const Topbar = () => {
   const dispatch = useDispatch()

   const handleLogOut = (e) => {
      e.preventDefault()
      logout(dispatch)
   }

   return (
      <Container>
         <Wrapper>
            <TopLeft>
               <Logo>LM Admin</Logo>
            </TopLeft>
            <TopRight>
               <Icons>
                  <NotificationsNone color="primary" />
                  <TopIconBadge>3</TopIconBadge>
               </Icons>
               <Icons>
                  <Language color="primary" />
               </Icons>
               <Icons>
                  <Settings color="primary" />
               </Icons>
               <TopAvatar
                  src="https://avatars.githubusercontent.com/u/119888833?v=4"
                  onClick={handleLogOut}
               />
            </TopRight>
         </Wrapper>
      </Container>
   )
}

export default Topbar
